<script setup lang="ts">
import { useLoginRedirect } from "@/composables/useLoginRedirect";

useLoginRedirect("corp");
</script>

<template>
  <q2-loading modifiers=""> </q2-loading>
</template>

<style scoped>
q2-loading {
  display: block;
  margin: 0 auto;
  margin-top: 1rem;
}
</style>
